export class DataController {
    DataController() {
        this.logedin;
    }

    getLogedin() {
        return this.logedin;
    }
    setLogedin(value) {
        this.logedin = value;
    }

    loginUser(username, password) {
        return new Promise((resolve, reject) => {

            var request = require('ajax-request');
            request(
                {
                    url: 'http://swiftservice.psoftwarestudio.com/Admin.php/?username=' + username + '&password=' + password,
                    headers: {}
                }
                , (error, res, body) => {
                    resolve(body);
                }
            );
        });
    }

    postaviTiket(naslovt, tekstt, emailt) {
        return new Promise((resolve, reject) => {
            var request = require('ajax-request');
            request(
                {
                    url: 'http://swiftservice.psoftwarestudio.com/Tiket.php',
                    method: "GET",
                    data: {
                        naslov: naslovt,
                        opis: tekstt,
                        email: emailt
                    },
                    headers: {}
                }
                , (error, res, body) => {
                    resolve(body);
                }
            );
        });
    }

    registrujFirmu(naziv_f, adresa_f, telefon_f, email_f, pib, mb, ime, prez, adresa_v, telefon_v, email_v, korisnicko, lozinka) {
        return new Promise((resolve, reject) => {
            var request = require('ajax-request');
            request(
                {
                    url: 'http://swiftservice.psoftwarestudio.com/RegistracijaKlijenta.php',
                    method: "GET",
                    data: {
                        nazivf: naziv_f,
                        adresaf: adresa_f,
                        telefonf: telefon_f,
                        emailf: email_f,
                        pibf: pib,
                        mbf: mb,
                        imev: ime,
                        prezimev: prez,
                        adresav: adresa_v,
                        telefonv: telefon_v,
                        emailv: email_v,
                        korisnickov: korisnicko,
                        lozinkav: lozinka
                    },
                    headers: {}
                }
                , (err, res, body) =>{
                    resolve(body);
                }
            )
        });
    }
}


// WEBPACK FOOTER //
// ./src/data-controller.js